import { HistoricDataViewSettings } from '~/Api/User/ProductGroup';

export enum ActionType {
	requestHistoricDataViewSettingsUpdate = 'ProductGroup.requestHistoricDataViewSettingsUpdate',
	receiveHistoricDataViewSettingsUpdate = 'ProductGroup.receiveHistoricDataViewSettingsUpdate',
	requestExport = 'ProductGroup.requestExport',
	receiveExport = 'ProductGroup.receiveExport',
}

export interface RequestHistoricDataViewSettingsUpdate {
	type: ActionType.requestHistoricDataViewSettingsUpdate;
	request: Promise<any>;
	id: string;
}

export interface ReceiveHistoricDataViewSettingsUpdate {
	type: ActionType.receiveHistoricDataViewSettingsUpdate;
	request: Promise<any>;
	historicDataViewSettings: HistoricDataViewSettings | null;
	id: string;
}

export interface RequestExport {
	type: ActionType.requestExport;
	request: Promise<any>;
}

export interface ReceiveExport {
	type: ActionType.receiveExport;
	request: Promise<any>;
}

export type Action =
	| RequestHistoricDataViewSettingsUpdate
	| ReceiveHistoricDataViewSettingsUpdate
	| RequestExport
	| ReceiveExport;
